import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { Eye } from 'lucide-react';
import { memo } from 'react';
import { formatRelativeTime } from '../../utils/time';
/**
 * Banner displayed at the top of a shared chat indicating view-only access.
 * Shows who shared the chat and when.
 */ export const ViewOnlyBanner = /*#__PURE__*/ memo(function ViewOnlyBanner({ sharedBy, sharedAt }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2 px-4 py-2 bg-muted/50 border-b border-border text-sm text-muted-foreground",
        "aria-live": "polite",
        "data-testid": Testids.assistant.viewOnlyBanner,
        children: [
            /*#__PURE__*/ _jsx(Eye, {
                className: "w-4 h-4 flex-shrink-0"
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        className: "font-medium text-foreground",
                        children: "View only"
                    }),
                    ' — ',
                    "Shared by ",
                    sharedBy.name,
                    " ",
                    formatRelativeTime(sharedAt)
                ]
            })
        ]
    });
});
